export class LocalStorageKeys {
  public static readonly SIGN_UP_CONFIRM_EMAIL = 'sign-up-confirm-email';
  public static readonly SIGN_UP_CONFIRM_PASSWORD = 'sign-up-confirm-password';

  public static readonly SESSION_ROLE = 'session-role';

  public static readonly SESSION_TENANT = 'session-tenant';
  public static readonly SESSION_TENANT_CHECKED = 'session-tenant-checked';

  public static readonly SELECTED_COMPETITION_ID = 'selected-competition-id';

  public static readonly CONTEST_TASK_DRAFT = 'contest-task-draft';
}
